<template>
  <div class="hot-statistics-box">
    <div ref="hotLabel" class="hot-label-content" :class="[isOverflow && isOpen ? 'hot-label-content-open' : '']">
      <span v-for="(item, index) in hotList" :key="index" :class="['label-item', 'label-item_' + index]"
        :title="item.content" @click="searchItem(item.content)">{{ item.content }}</span>
    </div>
    <span class="hot-label-arrow" :class="[!isOpen ? 'close' : '']" @click.stop="isOpen = !isOpen" v-show="isOverflow"><a-icon type="double-right"/></span>
    <a-modal centered :visible="visible" :footer="null" :width="960" :bodyStyle="{ 'height': '600px' }" @ok="modalClose"
      @cancel="modalClose">
      <a-tabs :activeKey="activeKey" @change="onChangeTab">
        <a-tab-pane v-for="item in hotTabs" :key="item.value" :tab="item.label">
          <!-- <hotTabContent v-if="item.value === 'all'" key="allList" :tagList="allTabList"></hotTabContent> -->
          <hotTabContent key="hotList" :tagList="hotList" @searchItem="searchItem"></hotTabContent>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </div>
</template>

<script>
import hotTabContent from './HotTabContent.vue';
const hotTabs = [
  { label: '热搜词', value: 'hot' },
]
export default {
  name: 'hotStatistic',
  components: {
    hotTabContent
  },
  data() {
    return {
      hotList: [
        {
          id: 0,
          content: 'CAP4'
        },
        {
          id: 1,
          content: '公文管理'
        },
        {
          id: 2,
          content: '流版签'
        },
        {
          id: 3,
          content: '微协同'
        },
        {
          id: 4,
          content: 'DEE'
        },
        {
          id: 5,
          content: 'M3'
        },
        {
          id: 51,
          content: '加密狗'
        },
        {
          id: 52,
          content: 'CoMi'
        },
        {
          id: 6,
          content: '全文检索'
        },
        {
          id: 7,
          content: '致信'
        },
        {
          id: 8,
          content: '组织模型'
        },
        {
          id: 9,
          content: '云联中心'
        },
        {
          id: 23,
          content: '安全问题'
        },
        {
          id: 10,
          content: '文化建设'
        },
        {
          id: 11,
          content: '文档中心'
        },
        {
          id: 12,
          content: '会议管理'
        },
        {
          id: 13,
          content: '档案集成'
        },
        {
          id: 14,
          content: '在线预览'
        },
        {
          id: 15,
          content: '在线编辑'
        },
        {
          id: 16,
          content: '考勤签到打卡'
        },
        {
          id: 17,
          content: '魔学院'
        },
        {
          id: 18,
          content: '电子邮件'
        },
        {
          id: 19,
          content: '短信'
        },
        {
          id: 20,
          content: '音视频'
        },
        {
          id: 21,
          content: '上传附件'
        },
        {
          id: 22,
          content: '协同驾驶舱'
        }
      ],
      recommendList: [],
      hotTabs,

      allTabList: [],
      hotTabList: [],
      recommendTabList: [],
      activeKey: 'hot',

      visible: false,
      isOverflow: false,
      isOpen: true,
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    // 点击某一项热搜或推荐时，发送点击值进行搜索操作
    searchItem(content) {
      // 若热搜或推荐关键值是通过弹窗选择的话，先关闭弹出，再进行搜索操作
      if (this.visible) {
        this.visible = false
      }

      // 向父组件发送热搜或推荐关键词进行搜索操作
      this.$emit("hotRecommend", content);
    },
    modalClose() {
      this.visible = false
    },
    onOpenList() {
      this.visible = true;

    },
    onChangeTab(val) {
      console.log('val', val)
      this.activeKey = val
    },
    handleResize() {
      const hotLabel = this.$refs.hotLabel;
      let  hotLabelHeight = 0;
      if (hotLabel) {
        hotLabelHeight = hotLabel.clientHeight
      }
      console.log(hotLabelHeight,1111111)
      if (hotLabelHeight>36) {
        this.isOverflow = true;
      } else {
        this.isOverflow = false;
      }
  }
  },
  mounted() {
    this.handleResize();
  }
};
</script>

<style scoped lang="scss">
.hot-statistics-box {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  margin-top: 20px;

  .hot-label-arrow {
    margin-left: 30px;
    display: inline-block;
    color: #007AFF;
    
    i{
      padding: 6px;
      cursor: pointer;
      transform: rotate(90deg);
      transition: all .3s;
    }

    &.close i{
      transform: rotate(270deg);
      transition: all .3s;
    }
  }
  .hot-label-content {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    flex: 1;

    &.hot-label-content-open{
      height: 36px;
    }
  }
  .label-item {
    display: inline-block;
    padding: 2px 10px;
    margin-right: 11px;
    margin-bottom: 10px;
    color: #007AFF;
    cursor: pointer;
    background: #eef6ff;
    border: 1px solid #b4d8ff;
    border-radius: 4px;

  }
}

.label-title {
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
}

.hot-label {
  color: red;
  /* width: calc(50% - 25px); */
}

.hot-recommend {
  margin-left: 50px;
}


.label-item_0 {
  color: #fe2d46
}

.label-item_1 {
  color: #f60
}

.label-item_2 {
  color: #faa90e;
}

@media screen and (max-width: 824px) {
  .hot-statistics-box{
    margin-top: 8px;
    .hot-label-content {
      margin-top: 8px;
    }
  }
}
</style>
